import { render } from "./RecipeDetail.vue?vue&type=template&id=2aba6f39"
import script from "./RecipeDetail.vue?vue&type=script&lang=js"
export * from "./RecipeDetail.vue?vue&type=script&lang=js"

import "./RecipeDetail.vue?vue&type=style&index=0&id=2aba6f39&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__